const DateFormatter = (value) => {
    const datex =new Date(value);
    return (datex.getMonth() + 1) + '/' + datex.getDate() + '/' +  datex.getFullYear();
}

export default DateFormatter;